"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReportingGoalReportDocument", {
    enumerable: true,
    get: function() {
        return ReportingGoalReportDocument;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _goal = require("../goal");
const _user = require("../user");
const _employeereport = require("./employee-report");
const ReportingGoalCategory = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string()
});
const ReportingGoalOutlook = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    color: _zod.z.string()
});
const ReportingGoalAlignment = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    assignee: _user.SkinnyEmployee,
    status: _goal.GoalStatus,
    outlook: ReportingGoalOutlook
});
const ReportingGoalReportDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    description: _zod.z.string(),
    status: _goal.GoalStatus,
    categories: _zod.z.array(ReportingGoalCategory),
    start_date: _zod.z.date(),
    end_date: _zod.z.date(),
    outlook: ReportingGoalOutlook,
    value: _zod.z.number(),
    target: _zod.z.number(),
    units: _zod.z.string(),
    goal_weight: _zod.z.number(),
    transparency: _goal.GoalTransparency,
    alignment: ReportingGoalAlignment,
    sharers: _zod.z.array(_user.SkinnyEmployee),
    assignee: _employeereport.ReportingEmployeeDocument,
    creation_date: _zod.z.date(),
    last_goal_status_update: _zod.z.date(),
    last_update: _zod.z.date()
});
